module.exports = __webpack_public_path__ + "images/backgrounds/dew/small.71633df28ad4038a6fb6.jpg";